import React from "react";
import { Popover, PopoverBody, PopoverHeader, OverlayTrigger } from "react-bootstrap";


export const SectionPopover = () => {

      // window.onresize = window.onload = function() {
  //     width = this.innerWidth;
  //     height = this.innerHeight;
  //     console.log(width)
  // }
    return (
        <Popover id="popover-basic" className="popover" placement={window.innerWidth < 800 ? "bottom" : "right"}>
        <PopoverHeader className="popover-header" as="h3">Information</PopoverHeader>
        <PopoverBody className="popover-body">
            To save a section, you must provide the Name, Description and Tags. Highlight the text you want to submit, and then click <strong>'Save'</strong>.
        </PopoverBody>
        </Popover>
    )
}